import { OnChangeParams } from 'baseui/select';
import { useState, useMemo } from 'react';
import { JobStatus } from '../../types/jobs';
import EnhancedLabeledSelect from '../ui/EnhancedLabeledSelect';
import { useRecoilValue } from 'recoil';
import { jobsStatusState } from '../../storage/jobStates';

type Props = {
  selectedJobStatusId?: string;
  onChangeJobStatusId?: (jobStatusId?: string) => void;
  onChangeJobStatus?: (jobStatus?: JobStatus) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  maxDropdownHeight?: string;
  smallContainer?: boolean;
  dropdownOffset?: string;
};
export function JobStatusSelect({
  selectedJobStatusId,
  onChangeJobStatusId,
  onChangeJobStatus,
  isFilter = true,
  label = 'Estado:',
  emptyOptionText = 'Seleciona un estado',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  maxDropdownHeight,
  smallContainer,
  dropdownOffset,
}: Readonly<Props>) {
  const jobStatusList = useRecoilValue(jobsStatusState);
  const [selectedJobStatusOption, setSelectedJobStatusOption] = useState<{ id: string; label: string }>();

  const jobStatusOptions = useMemo(() => {
    if (!jobStatusList) return;
    const coreJobStatusOptions = jobStatusList.map((jobStatus) => ({ id: jobStatus.value, label: jobStatus.name }));
    const jobStatusOptions = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreJobStatusOptions,
        ]
      : coreJobStatusOptions;
    if (selectedJobStatusOption) {
      if (!jobStatusOptions.find((c) => c.id === selectedJobStatusOption.id))
        jobStatusOptions.push(selectedJobStatusOption);
    }
    return jobStatusOptions;
  }, [jobStatusList]);

  const onJobStatusChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeJobStatusId && onChangeJobStatusId(params.option.id as string);
      onChangeJobStatus &&
        onChangeJobStatus({
          statusType: params.option?.id,
          name: params.option?.label,
        } as JobStatus);
    } else {
      onChangeJobStatusId && onChangeJobStatusId(undefined);
      onChangeJobStatus && onChangeJobStatus(undefined);
    }
    setSelectedJobStatusOption(params.option as { id: string; label: string });
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={jobStatusOptions}
      value={showEmptyOption || selectedJobStatusId !== undefined ? [{ id: selectedJobStatusId }] : undefined}
      onChange={onJobStatusChange}
      fullWidth
      onBlur={() => {
        onBlur && onBlur();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      // onAdd={onAddClick}
      maxDropdownHeight={maxDropdownHeight}
      smallContainer={smallContainer}
      dropdownOffset={dropdownOffset}
    />
  );
}
